// Centralized image URLs for the Fitnession application
// Using high-quality Unsplash images for professional appearance

const images = {
  // Hero/Banner Images
  hero: {
    main: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1920&q=80',
    program: 'https://images.unsplash.com/photo-1549060279-7e168fcee0c2?w=1920&q=80',
    success: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1920&q=80',
    faq: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1920&q=80',
    about: 'https://images.unsplash.com/photo-1571019613576-2b22c76fd955?w=1920&q=80',
  },

  // Auth Pages (Login/Register side images)
  auth: {
    login: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200&q=80',
    register: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1200&q=80',
    forgotPassword: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200&q=80',
  },

  // Feature/Section Images
  features: {
    medication: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?w=800&q=80',
    coaching: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    nutrition: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
    exercise: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80',
    sleep: 'https://images.unsplash.com/photo-1541480601022-2308c0f02487?w=800&q=80',
    mentalHealth: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
    lifestyle: 'https://images.unsplash.com/photo-1571019613576-2b22c76fd955?w=800&q=80',
    technology: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80',
    community: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80',
    doctor: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80',
    consultation: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    delivery: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80',
  },

  // Six Pillars Images
  pillars: {
    glp1: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=600&q=80',
    exercise: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&q=80',
    nutrition: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600&q=80',
    sleep: 'https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=600&q=80',
    mentalHealth: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600&q=80',
    lifestyle: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80',
  },

  // Success Stories / Testimonials (diverse professional headshots)
  testimonials: {
    person1: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    person2: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
    person3: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&q=80',
    person4: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    person5: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    person6: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80',
    person7: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80',
    person8: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80',
  },

  // Transformation/Results Images
  transformations: {
    beforeAfter: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80',
    progress: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
    celebration: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=800&q=80',
    running: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=800&q=80',
    yoga: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
  },

  // Dashboard Images
  dashboard: {
    weightProgress: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&q=80',
    workout: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&q=80',
    nutrition: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&q=80',
    sleep: 'https://images.unsplash.com/photo-1541480601022-2308c0f02487?w=400&q=80',
  },

  // Program/How It Works
  howItWorks: {
    assessment: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&q=80',
    doctorConsult: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80',
    delivery: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&q=80',
    coaching: 'https://images.unsplash.com/photo-1571019613576-2b22c76fd955?w=600&q=80',
    progress: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&q=80',
    success: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=600&q=80',
  },

  // Trust/Credibility Images
  trust: {
    fda: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=300&q=80',
    doctors: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80',
    lab: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=600&q=80',
    secure: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&q=80',
  },

  // Healthy Food Images
  food: {
    salad: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&q=80',
    breakfast: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=600&q=80',
    smoothie: 'https://images.unsplash.com/photo-1502741224143-90386d7f8c82?w=600&q=80',
    mealPrep: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600&q=80',
    vegetables: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=600&q=80',
    protein: 'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=600&q=80',
  },

  // Exercise/Fitness Images
  fitness: {
    gym: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&q=80',
    running: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=600&q=80',
    yoga: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&q=80',
    stretching: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&q=80',
    weights: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&q=80',
    outdoors: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=600&q=80',
  },

  // Medical/Healthcare Images
  medical: {
    doctor: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80',
    consultation: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80',
    telehealth: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&q=80',
    medication: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=600&q=80',
    checkup: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80',
  },

  // Patterns and Backgrounds
  backgrounds: {
    pattern1: 'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%230ea5e9" fill-opacity="0.05"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E',
    gradient1: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)',
    gradient2: 'linear-gradient(135deg, #0c4a6e 0%, #14532d 100%)',
  },

  // Placeholder for when images fail to load
  placeholder: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&q=80',
};

export default images;

// Helper function to get optimized image URL with Unsplash parameters
export const getOptimizedImage = (url, width = 1920, quality = 80) => {
  if (url && url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return `${baseUrl}?w=${width}&q=${quality}&fit=crop&auto=format`;
  }
  return url;
};

// Helper function for responsive images
export const getResponsiveImageSet = (url) => {
  if (url && url.includes('unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return {
      small: `${baseUrl}?w=400&q=80&fit=crop&auto=format`,
      medium: `${baseUrl}?w=800&q=80&fit=crop&auto=format`,
      large: `${baseUrl}?w=1200&q=80&fit=crop&auto=format`,
      xlarge: `${baseUrl}?w=1920&q=80&fit=crop&auto=format`,
    };
  }
  return { small: url, medium: url, large: url, xlarge: url };
};

// Preload critical images for better performance
export const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;
    document.head.appendChild(link);
  });
};
